import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const useContactColumns = () => {
    const { t } = useTranslation()

    const columns = [
        {
            header: t('app.common.id'),
            id: 'contact',
            enableSorting: false,
            size: 50,
            cell: ({ row }) => row.original?.contact?.internalAppId,
        },
        {
            header: t('app.common.contact.nameAndSurname'),
            id: 'contactPersonName',
            enableSorting: false,
            size: 235,
            cell: ({ row }) => {
                const contactPerson = row.original?.contact?.contactPerson
                return `${contactPerson?.firstName ?? ''} ${contactPerson?.lastName ?? ''}`
            },
        },
        {
            header: t('app.common.company.name'),
            id: 'contactCompanyName',
            enableSorting: false,
            size: 180,
            cell: ({ row }) => {
                const contact = row.original?.contact

                // contactPersonCompanyName - name of company related to person
                // contactCompanyName - name of standalone company
                const contactPersonCompanyName = contact?.contactPersonCompany?.[0]?.company?.contactCompany?.name ?? ''
                const contactCompanyName = contact?.contactCompany?.name ?? ''

                return contactPersonCompanyName || contactCompanyName
            },
        },
        {
            header: t('app.common.contactPhoneNumber1'),
            id: 'contactPhone',
            enableSorting: false,
            size: 135,
            cell: ({ row }) => row.original?.contact?.contactPhone?.[0]?.phoneNumber ?? '',
        },
        {
            header: t('app.common.email.label'),
            id: 'contactEmail',
            enableSorting: false,
            size: 280,
            cell: ({ row }) => row.original?.contact?.contactEmail?.[0]?.email ?? '',
        },
        {
            header: t('app.common.agent'),
            id: 'agent',
            enableSorting: false,
            size: 200,
            cell: ({ row }) => {
                const agent = row.original?.contact?.agent
                return `${agent?.firstName ?? ''} ${agent?.lastName ?? ''}`
            },
        },
        {
            id: 'actions',
            enableSorting: false,
            meta: { tdClass: 'text-center' },
            cell: ({ row }) => {
                const contactType = row.original?.contact?.contactType
                const urlBase = contactType === 'person' ? 'contacts' : 'companies'

                return (
                    <ul className="list-inline hstack gap-2 mb-0 justify-content-center">
                        <li className="list-inline-item edit">
                            <Link
                                target="_blank"
                                rel="noopener noreferrer"
                                title={t('button.view')}
                                to={`/${urlBase}/${row.original?.contact?.id}`}
                                className="text-info d-inline-block edit-item-btn"
                            >
                                <i className="mdi mdi-eye-outline fs-16"></i>
                            </Link>
                        </li>
                    </ul>
                )
            },
            size: 40,
        },
    ]

    return columns
}

export default useContactColumns
